// Logger levels
export const LogLevel = {
    NONE: 0,   // No logging at all
    ERROR: 1,  // Only errors
    WARN: 2,   // Errors and warnings
    INFO: 3,   // Errors, warnings, and info
    DEBUG: 4   // All logging (most verbose)
};

// Default log level
let currentLogLevel = LogLevel.INFO;

// Check if we're in a browser environment
const isBrowser = typeof window !== 'undefined';

// Simple debug logger utility with verbosity control
export const debugLogger = {
    // Set the current log level
    setLogLevel: (level) => {
        currentLogLevel = level;
        console.log(`[LOGGER] Log level set to ${Object.keys(LogLevel).find(key => LogLevel[key] === level) || level}`);
    },
    
    // Get the current log level
    getLogLevel: () => currentLogLevel,
    
    error: (context, message, error) => {
        if (currentLogLevel >= LogLevel.ERROR) {
            console.error(`[${context}] ${message}:`, error);
        }
    },
    
    warn: (context, message, data = null) => {
        if (currentLogLevel >= LogLevel.WARN) {
            console.warn(`[${context}] ${message}`, data || '');
        }
    },
    
    info: (context, message, data = null) => {
        if (currentLogLevel >= LogLevel.INFO) {
            console.log(`[${context}] ${message}`, data || '');
        }
    },
    
    debug: (context, message, data = null) => {
        if (currentLogLevel >= LogLevel.DEBUG) {
            console.log(`[DEBUG:${context}] ${message}`, data || '');
        }
    }
};

// Export a simplified client-side console wrapper
export const clientLogger = {
    setLogLevel: (level) => {
        if (isBrowser && window.localStorage) {
            try {
                localStorage.setItem('logLevel', level);
            } catch (e) {
                console.warn('Failed to save log level to localStorage:', e);
            }
        }
        currentLogLevel = level;
        console.log(`Log level set to ${Object.keys(LogLevel).find(key => LogLevel[key] === level) || level}`);
    },
    
    error: (...args) => {
        if (currentLogLevel >= LogLevel.ERROR) {
            console.error(...args);
        }
    },
    
    warn: (...args) => {
        if (currentLogLevel >= LogLevel.WARN) {
            console.warn(...args);
        }
    },
    
    info: (...args) => {
        if (currentLogLevel >= LogLevel.INFO) {
            console.log(...args);
        }
    },
    
    debug: (...args) => {
        if (currentLogLevel >= LogLevel.DEBUG) {
            console.log('[DEBUG]', ...args);
        }
    }
};

// Initialize log level from localStorage if available
if (isBrowser && window.localStorage) {
    try {
        const savedLogLevel = localStorage.getItem('logLevel');
        if (savedLogLevel !== null) {
            currentLogLevel = parseInt(savedLogLevel, 10);
        }
    } catch (e) {
        // Ignore errors reading from localStorage
        console.warn('Failed to read log level from localStorage:', e);
    }
} 